import { connect } from 'react-redux';

import Third from './Third.js';
import { redux as apiRedux } from '../api';
const { setPrevPage } = apiRedux.actions;
const mapStateToProps = state => {
  return {
    user: state.api.user.info,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPrevPage: data => dispatch(setPrevPage(data)),
  };
};

const ConnectedThird = connect(
  mapStateToProps,
  mapDispatchToProps
)(Third);

export default ConnectedThird;
